/**
 * @brisa/ui · components/ui/badge — shadcn Badge (Facelift v1)
 *
 * Feature: migracao-facelift-v1 · ADR §D6 + COMPONENT_MAP §1 #11 (section-tag)
 *
 * Variantes cva per F1-BDG-01..02:
 *   - outline-caps     → section-tag CAPS (uppercase + tracking-wider + border)
 *   - section-tag-dark → variant escura sobre canvas sage
 *   - section-tag-sage → variant sage-light (lowercase)
 *   - verified-partner → "B" amarelo sobre fundo amarelo (selo parceiro ClubCard)
 *
 * Sem 'use client' (F1-RSC-09) — apresentacional puro.
 */
import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '../../lib/utils';

export const badgeVariants = cva(
  'inline-flex items-center justify-center rounded-full px-3 py-1 text-xs font-medium ' +
    'transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-accent-yellow text-foreground',
        'outline-caps':
          'border border-[hsl(var(--text-16))] bg-transparent text-[hsl(var(--text-64))] uppercase tracking-wider',
        'section-tag-dark':
          'border-transparent bg-[hsl(var(--text-08))] text-[hsl(var(--text-64))] uppercase tracking-wider',
        'section-tag-sage':
          'border-transparent bg-[hsl(var(--text-08))] text-[hsl(var(--text-64))] normal-case',
        'verified-partner':
          'border-transparent bg-accent-yellow text-foreground font-bold h-5 w-5 rounded-full p-0 text-[10px]',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline: 'border border-border text-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}
